import { Link, useLocation } from "react-router-dom";
import { routes } from "../../App";
import styles from "./Navbar.module.scss";

export const Navbar = () => {
  const location = useLocation();

  return (
    <div className={styles.navWrapper}>
      <div className={styles.nav}>
        {routes
          .filter((route) => route.rootPath)
          .map((route, index) => (
            <Link
              className={`${styles.navItem} ${
                location.pathname === route.path ? styles.navItemActive : ""
              }`}
              key={index}
              to={route.path}
            >
              {route.icon}
              <div>{route.name}</div>
            </Link>
          ))}
      </div>
    </div>
  );
};
